/**
 * マスタ由来の色の値を検証する (docs/13 §7)。
 *
 * マスタの色は SVG 文字列 (`innerHTML`) や `style.cssText` に埋め込まれることがあり、
 * `"` `<` `;` などを含む値が保存されるとマークアップや CSS を壊せる (XSS / CSS 注入)。
 * 許可するのは次の形式だけ:
 *   - `#rgb` / `#rgba` / `#rrggbb` / `#rrggbbaa`
 *   - `rgb()` / `rgba()` / `hsl()` / `hsla()` (中身は数字・`.`・`%`・`,`・空白・`/`・`deg` のみ)
 *   - 英字だけの色名 (`red`、`transparent` 等。3〜20 文字)
 */
const HEX_RE = /^#(?:[0-9a-fA-F]{3}|[0-9a-fA-F]{4}|[0-9a-fA-F]{6}|[0-9a-fA-F]{8})$/;
const FUNC_RE = /^(?:rgb|rgba|hsl|hsla)\(\s*[0-9.%,\s/deg+-]{1,60}\)$/i;
const NAMED_RE = /^[a-zA-Z]{3,20}$/;

/** 色として安全に埋め込める値か。 */
export function isSafeCssColor(value: unknown): value is string {
  if (typeof value !== 'string') return false;
  const v = value.trim();
  if (v.length === 0 || v.length > 64) return false;
  return HEX_RE.test(v) || FUNC_RE.test(v) || NAMED_RE.test(v);
}

/** 安全な色ならそのまま (前後空白は除去)、そうでなければ `fallback` を返す。 */
export function safeCssColor(value: unknown, fallback: string): string {
  return isSafeCssColor(value) ? value.trim() : fallback;
}
